import { render } from "./ModalPrivacy.vue?vue&type=template&id=6d450834&scoped=true"
import script from "./ModalPrivacy.vue?vue&type=script&lang=js"
export * from "./ModalPrivacy.vue?vue&type=script&lang=js"

import "./ModalPrivacy.vue?vue&type=style&index=0&id=6d450834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d450834"]])

export default __exports__